import React, { Component } from "react";
import { connect } from 'react-redux';
import Actions from '../Actions';
import Search from "../Search";
import Empty from "../Empty";
import Tenant from "../Tenant";
import Avatar from "../Avatar";
import { Link } from 'react-router-dom';
import { PATHS } from '../../common/constants';
import { selectAuthenticatedUser } from "../../store/selectors/auth";
import { selectSearch } from "../../store/selectors/search";
import Table from "../Table";
import { onRequestPhoneCall } from "../../helpers/validationHelper";

class KeyContactsTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showOverlay: false
        }
    }
    render() {
        const { keyContacts, onSearch, search } = this.props
        const theme = localStorage.getItem('theme');
        return (
            <>
                <Actions compact>
                    <Search
                        size="small"
                        placeholder="Search Key Contacts..."
                        onChange={onSearch}
                    />
                </Actions>
                {
                    keyContacts.length > 0 ?
                        (
                            <div
                            style={{
                              height: 550,
                              overflow: "auto",
                              display: "flex",
                              flexDirection: "column",
                            }}
                          >
                            <Table
                                columns={
                                    theme === "Shape" ? 
                                    [
                                        {
                                            label: 'Key Contact',
                                            sortable: true,
                                            accessor: 'name',
                                            cell: data => {
                                                return (
                                                    <Link
                                                        to={{
                                                            pathname: PATHS.KEY_CONTACTS_VIEW.replace(':id', data.id),
                                                            state: {keyContact: data}
                                                        }}
                                                    >
                                                        <Tenant
                                                            headline={`${data.name}`}
                                                            avatar={(
                                                                <Avatar
                                                                // badge={'home-owner'}
                                                                url={data.profileImage}
                                                                />
                                                            )}
                                                        />
                                                    </Link>
                                                )
                                            }
                                        },
                                        
                                      {
                                            label: 'Phone',
                                            accessor: 'phone',
                                            cell: data => onRequestPhoneCall(data.phone)
                                        }, {
                                            xsHide: true,
                                            label: 'Email',
                                            accessor: 'email',
                                        }
    
                                    ]
                                    : 
                                    [
                                    {
                                        label: 'Key Contact',
                                        sortable: true,
                                        accessor: 'name',
                                        cell: data => {
                                            return (
                                                <Link
                                                    to={{
                                                        pathname: PATHS.KEY_CONTACTS_VIEW.replace(':id', data.id),
                                                        state: {keyContact: data}
                                                    }}
                                                >
                                                    <Tenant
                                                        headline={`${data.name}`}
                                                        avatar={(
                                                            <Avatar
                                                            // badge={'home-owner'}
                                                            url={data.profileImage}
                                                            />
                                                        )}
                                                    />
                                                </Link>
                                            )
                                        }
                                    },
                                    {
                                        label: 'Description',
                                        accessor: 'department',
                                    }, {
                                        label: 'Phone',
                                        accessor: 'phone',
                                        cell: data => onRequestPhoneCall(data.phone)
                                    }, {
                                        xsHide: true,
                                        label: 'Email',
                                        accessor: 'email',
                                    }

                                ]}
                                data={keyContacts}
                            />
                            </div>
                        )
                        :
                        (
                            <Empty
                                direction="ttb"
                                headline="No key contacts yet"
                                strapline=" all your key contacts here so it’s easier for you to manage."
                                searchIsActive={search && search.contacts ? search.contacts : ''}
                                cta={null}
                                image={(
                                    <img
                                        alt="No key contacts yet"
                                        src="/assets/empty/contacts.svg"
                                    />
                                )}
                            />
                        )
                }
            </>

        )
    }
}

const mapStateToProps = state => ({
    user: selectAuthenticatedUser(state),
    search: selectSearch(state)
});

export default connect(mapStateToProps, null)(KeyContactsTable);